import React from 'react';
import { Link } from 'react-router-dom';

const CoursesSection = () => {
  const courses = [
    {
      name: 'Certificate in Food Handlers',
      description: 'A professional training program that provides essential knowledge of food safety and hygiene practices for safe food handling and preparation.',
      image: '/food-handler.jpg'
    },
    {
      name: 'Certificate in CPR and First Aid',
      description: 'A practical training program that provides essential life-saving skills to respond confidently and effectively in emergency situations.',
      image: '/first-aid.jpg'
    },
    {
      name: 'Certificate in Food Service Worker',
      description: 'Training program that develops essential food service, hygiene, and customer care skills.',
      image: '/food.jpg'
    }
  ];

  return (
    <section className="courses">
      <div className="container">
        <h2 className="section-title">Our Popular Courses</h2>
        <div className="courses-grid">
          {courses.map((course, index) => (
            <div key={index} className="course-card">
              <div className="course-image">
                <img src={course.image} alt={course.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
              <div className="course-content">
                <h3>{course.name}</h3>
                <p>{course.description}</p>
                <p>*Please note that these programs are non-vocational and do not require approval under the Ontario Career Colleges Act, 2005</p>
                <Link to="/courses" className="btn btn-primary">View Details</Link>
              </div>
            </div>
          ))}
        </div>
        {/* <div style={{ textAlign: 'center', marginTop: '2rem' }}>
          <Link to="/courses" className="btn btn-primary">View All Courses</Link>
        </div> */}
      </div>
    </section>
  );
};

export default CoursesSection;
